// extracted by mini-css-extract-plugin
module.exports = {"input":"mxHFD2"};